/** Font roles saved in website_settings (see migration 001). */
export const FONT_ASSIGNMENTS = [
  { key: 'font_hero_heading', label: 'Hero — couple names', default: "'Bargiery', 'Great Vibes', cursive" },
  { key: 'font_hero_body', label: 'Hero — wedding date', default: "'Montserrat', sans-serif" },
  { key: 'font_section_heading', label: 'Section headings', default: "'Cormorant Garamond', serif" },
  { key: 'font_body_text', label: 'Body text', default: "'Montserrat', sans-serif" },
  { key: 'font_navigation', label: 'Navigation menu', default: "'Montserrat', sans-serif" },
  { key: 'font_button', label: 'Buttons', default: "'Montserrat', sans-serif" },
  { key: 'font_modal_heading', label: 'Modal headings', default: "'Cormorant Garamond', serif" },
  { key: 'font_modal_body', label: 'Modal body text', default: "'Montserrat', sans-serif" },
];

export const CSS_VAR_BY_SETTING = {
  font_hero_heading: '--font-hero-heading',
  font_hero_body: '--font-hero-body',
  font_section_heading: '--font-heading',
  font_body_text: '--font-body',
  font_navigation: '--font-navigation',
  font_button: '--font-button',
  font_modal_heading: '--font-modal-heading',
  font_modal_body: '--font-modal-body',
};

export const BUILTIN_FONTS = [
  { value: "'Cormorant Garamond', serif", label: 'Cormorant Garamond (Google)' },
  { value: "'Montserrat', sans-serif", label: 'Montserrat (Google)' },
  { value: "'Great Vibes', cursive", label: 'Great Vibes (Google)' },
  { value: "'Playfair Display', serif", label: 'Playfair Display (Google)' },
  { value: "'Poppins', sans-serif", label: 'Poppins (Google)' },
  { value: "'Bargiery', 'Great Vibes', cursive", label: 'Bargiery (add to public/fonts or upload)' },
  { value: 'Georgia, serif', label: 'Georgia (system)' },
  { value: 'Arial, sans-serif', label: 'Arial (system)' },
];

const FORMAT_MAP = {
  woff2: 'woff2',
  woff: 'woff',
  ttf: 'truetype',
  otf: 'opentype',
};

export function formatToCss(format) {
  return FORMAT_MAP[String(format || '').toLowerCase()] || 'opentype';
}

/** Quote a single font name for use in a font-family stack. */
export function quoteFontName(name) {
  const trimmed = String(name || '').trim();
  if (!trimmed) return '';
  if (trimmed.includes(',')) return trimmed;
  if (trimmed.startsWith("'") || trimmed.startsWith('"')) return trimmed;
  return `'${trimmed.replace(/'/g, "\\'")}'`;
}

export function customFontFamilyValue(font) {
  const base = quoteFontName(font.font_family);
  const fallback = ['woff', 'woff2', 'ttf', 'otf'].includes(font.file_format) ? 'sans-serif' : 'serif';
  return `${base}, ${fallback}`;
}

export function resolveFontAssignments(settings = {}) {
  const resolved = {};
  FONT_ASSIGNMENTS.forEach(({ key, default: fallback }) => {
    const raw = settings[key];
    resolved[key] = raw && String(raw).trim() ? String(raw).trim() : fallback;
  });
  return resolved;
}

export function buildTypographyCssVars(settings = {}) {
  const assignments = resolveFontAssignments(settings);
  return Object.entries(CSS_VAR_BY_SETTING)
    .map(([key, cssVar]) => `${cssVar}: ${assignments[key]};`)
    .join('\n');
}

export function buildFontFaceCss(fonts = [], getUrl) {
  if (!fonts.length || typeof getUrl !== 'function') return '';
  return fonts
    .map((font) => {
      const family = quoteFontName(font.font_family);
      const url = getUrl(`uploads/fonts/${font.filename}`);
      const format = formatToCss(font.file_format);
      return `@font-face {
  font-family: ${family};
  src: url('${url}') format('${format}');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}`;
    })
    .join('\n\n');
}
